import * as Api from '@ViewModels';
import { ISatisfactionSurveyResponse } from '../../../extViewmodels/sdk/models';
import { IImpersonationContextComponentProps } from '../../../models';
import { ImpersonationContextViewModel } from '../../../viewmodels/AdminViewModels';
import { ActiveGoogleBusinessReview } from '../Happiness/DashboardGoogleBusinessProfileCard';

export type LayoutElement = 'text' | 'stars' | 'logo' | 'author';

export const LAYOUT_ELEMENT_LABELS: Record<LayoutElement, string> = {
	text: 'Quote',
	stars: 'Stars',
	logo: 'Logo',
	author: 'Author',
};

export type TestimonialCreationStep = 'generating' | 'creating';

export type TestimonialSource =
	| { type: 'google_review'; data: ActiveGoogleBusinessReview }
	| { type: 'survey_response'; data: ISatisfactionSurveyResponse };

export interface LocationState {
	viewModel?: any;
	model?: {
		sendFromUser?: any;
		[key: string]: any;
	};
	review?: ActiveGoogleBusinessReview;
	surveyResponse?: ISatisfactionSurveyResponse;
}

export interface TestimonialImageEditorProps {
	accountId?: string;
	impersonationContext?: ImpersonationContextViewModel | Api.IImpersonationContext;
	testimonial: TestimonialSource;
	nextState?: LocationState;
	containerStyles?: React.CSSProperties[];
	builderStyles?: React.CSSProperties[];
	onPostCreated?: () => void;
}

export interface TestimonialControlsProps extends Omit<IImpersonationContextComponentProps, 'impersonationContext'> {
	impersonationContext?: ImpersonationContextViewModel | Api.IImpersonationContext;
	builderStyles?: React.CSSProperties[];
	bgColor: string;
	textColor: string;
	reviewText: string;
	authorName: string;
	includeGoogleLogo: boolean;
	includeAuthor: boolean;
	includeStars: boolean;
	sourceType: 'google_review' | 'survey_response';
	isContentTooLong: boolean;
	createPostDisabled?: boolean;
	fontSize?: number;
	fontSizeLabel?: string;
	onFontSizeChange: (fontSize: number) => void;
	summarizeReviewId?: string;
	onBgColorChange: (color: string) => void;
	onTextColorChange: (color: string) => void;
	onReviewTextChange: (text: string) => void;
	onAuthorNameChange: (name: string) => void;
	onIncludeGoogleLogoChange: () => void;
	onIncludeAuthorChange: () => void;
	onIncludeStarsChange: () => void;
	onGenerateImage: () => void;
	onSendFromChange: (user?: Api.UserViewModel | null) => void;
	onBackgroundImageChange: (image: { slug: string; fileAttachment: Api.IFileAttachment } | null) => void;
	/** Initial background image (e.g. from account preferences). Used when in impersonation context. */
	initialBackgroundImage?: { slug: string; fileAttachment: Api.IFileAttachment } | null;
}

export interface TestimonialPreviewProps {
	isCreatingDraft: boolean;
	errorMessage: string | null;
	canvas?: Api.IGoogleReviewPostCanvas;
	previewHtml: string | null;
	previewError: string | null;
	onCreateDraft: (imageUrl: string | null, fileAttachment?: any) => void;
	onTextOverflowChange: (overflows: boolean) => void;
	layout?: Api.IGoogleReviewPostLayout;
	visibleElements: LayoutElement[];
	selectedElement: LayoutElement;
	onSelectElement: (element: LayoutElement) => void;
	onLayoutBoxChange: (element: LayoutElement, box: Api.IGoogleReviewPostLayoutBox) => void;
	reviewText: string;
	textColor: string;
	onReviewTextChange: (text: string) => void;
	canSaveDefaults: boolean;
	isSavingDefaults: boolean;
	onSaveDefaults: () => void;
}
export interface StoredPreferences {
	bgColor: string;
	textColor: string;
	includeGoogleLogo: boolean;
	includeAuthor: boolean;
	includeStars: boolean;
}
